import * as React from 'react';
import { ILocatorOverrides } from '../../../types/utility';
import { createLocators } from '@u1/locators';
import clsx from 'clsx';

import useStyles from './Link.styles';

export const linkLocators = createLocators({
  name: 'Link',
  componentLocators: ['link'],
});
const { locators } = linkLocators();

export interface ILinkProps
  extends Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'className'>,
    ILocatorOverrides {
  /**
   * Disables link interaction
   */
  disabled?: boolean;
}

const Link: React.FC<React.PropsWithChildren<ILinkProps>> = ({
  disabled,
  locatorsOverrides,
  children,
  ...linkProps
}) => {
  const classes = useStyles();

  return (
    <a
      {...locators.link({ disabled })}
      {...locatorsOverrides}
      className={clsx({ [classes.root]: true, [classes.disabled]: disabled })}
      {...linkProps}
    >
      {children}
    </a>
  );
};

export default Link;
